import {
    IonHeader,
    IonLabel,
    IonSegment,
    IonSegmentButton,
} from "@ionic/react";
import React, { useEffect, useState } from "react";

interface _Props {
    active: string
    onSelect: Function
}

const ViewPersonNavbar: React.FC<_Props> = ({active, onSelect}) => {
    const [currentActiveBtn, setCurrentActiveBtn] = useState(active || "about");

    useEffect(() => {
        setCurrentActiveBtn(active);
    }, [active]);

    const handleSelection = async (selection: string) => {
        await setCurrentActiveBtn(selection);
        onSelect(selection);
    }

    return (
        <IonHeader id="viewPersonMenu">
            <IonSegment color="primary" mode="md" value={currentActiveBtn || active} scrollable={true} onIonChange={e => {handleSelection(e.detail.value || "about");}}>
                <IonSegmentButton value="about">
                    <IonLabel>About</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="clinics">
                    <IonLabel>Clinics</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="barns">
                    <IonLabel>Barns</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="entries">
                    <IonLabel>Entries</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="duplicate">
                    <IonLabel>Duplicates</IonLabel>
                </IonSegmentButton>
            </IonSegment>
        </IonHeader>
    );
};

export default ViewPersonNavbar;
